var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 46,
    viewBox: "0 0 45 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 48097809"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 11539"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M22.6684 17.7871C19.5087 17.7871 16.938 20.3578 16.938 23.5175C16.938 26.6773 19.5087 29.248 22.6684 29.248C25.8282 29.248 28.3989 26.6773 28.3989 23.5176C28.3989 20.3578 25.8282 17.7871 22.6684 17.7871Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M30.0435 7.1875L15.2895 7.1875C10.3525 7.1875 6.33594 11.2041 6.33594 16.1411L6.33594 30.8951C6.33594 35.8322 10.3525 39.8487 15.2895 39.8487H30.0435C34.9806 39.8487 38.9971 35.8321 38.9971 30.8951V16.1411C38.9971 11.2041 34.9806 7.1875 30.0435 7.1875ZM22.6665 32.4764C17.7268 32.4764 13.7082 28.4578 13.7082 23.5181C13.7082 18.5784 17.7269 14.5599 22.6665 14.5599C27.6061 14.5599 31.6249 18.5785 31.6249 23.5181C31.6249 28.4577 27.6061 32.4764 22.6665 32.4764ZM32.1606 16.7457C30.6599 16.7457 29.4389 15.5248 29.4389 14.024C29.4389 12.5233 30.6599 11.3022 32.1606 11.3022C33.6614 11.3022 34.8824 12.5232 34.8824 14.024C34.8824 15.5247 33.6614 16.7457 32.1606 16.7457Z",
    fill: "white"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.6a10cfba49aa64578d2bfd269f78e599.svg";
export { ForwardRef as ReactComponent };